var render = function render(){var _vm=this,_c=_vm._self._c;return _c('article',{staticClass:"unit-card-container"},[(_vm.to)?_c('router-link',{staticClass:"unit-card-container__link",attrs:{"to":_vm.to}},[_vm._t("default")],2):_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }